import React from "react";
import { ShieldCheck, Zap, FileCheck2, Network } from "lucide-react";

export const BrandMark = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 38 L20 8 L28 8 L14 38 Z" fill="#e11d63" />
    <path d="M20 38 L34 8 L42 8 L28 38 Z" fill="#1d4ed8" />
    <path d="M26 24 L33 24 L30 31 Z" fill="#0ea5e9" />
  </svg>
);

const points = [
  { icon: Zap, t: "Instant VAT-compliant e-Invoices", d: "12 autonomous agents generate & report invoices in seconds." },
  { icon: FileCheck2, t: "Automatic VAT returns", d: "Returns prepared continuously — zero manual entry." },
  { icon: Network, t: "Peppol 5-corner delivery", d: "Supplier → ASP → ASP → Buyer → FTA, fully orchestrated." },
  { icon: ShieldCheck, t: "No human-in-the-loop", d: "Every step is agent-run, validated and audit-ready." },
];

const AuthShell = ({ title, subtitle, children, footer }) => (
  <div className="min-h-screen flex bg-[#f4f5f7]">
    {/* Left brand panel */}
    <div className="hidden lg:flex lg:w-[46%] relative overflow-hidden bg-gradient-to-br from-indigo-600 via-violet-600 to-fuchsia-600 text-white p-12 flex-col justify-between">
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-xl bg-white flex items-center justify-center"><BrandMark size={28} /></div>
        <span className="text-2xl font-bold tracking-tight">InSolutions</span>
      </div>
      <div>
        <h2 className="text-3xl font-bold leading-tight">Agentic AI e-Invoicing<br />for the UAE & beyond</h2>
        <p className="text-white/80 mt-3 max-w-md">A fully autonomous platform where AI agents handle ingestion, VAT reasoning, e-invoice generation and tax-authority reporting end-to-end.</p>
        <div className="mt-8 space-y-4 max-w-md">
          {points.map((p) => (
            <div key={p.t} className="flex items-start gap-3">
              <div className="w-9 h-9 rounded-lg bg-white/15 flex items-center justify-center shrink-0"><p.icon size={18} /></div>
              <div>
                <p className="font-semibold">{p.t}</p>
                <p className="text-sm text-white/75">{p.d}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <p className="text-xs text-white/60">© {new Date().getFullYear()} InSolutions · Approved e-Invoicing technology</p>
    </div>

    {/* Right form area */}
    <div className="flex-1 flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="flex lg:hidden items-center gap-2 mb-6 justify-center">
          <BrandMark size={28} /><span className="text-xl font-bold">InSolutions</span>
        </div>
        <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
        {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
        <div className="mt-6">{children}</div>
        {footer && <div className="mt-6 text-sm text-center text-gray-500">{footer}</div>}
      </div>
    </div>
  </div>
);

export const Field = ({ label, children }) => (
  <div className="mb-4">
    <label className="block text-sm font-medium text-gray-700 mb-1.5">{label}</label>
    {children}
  </div>
);

export const inputCls =
  "w-full px-3.5 py-2.5 text-sm rounded-lg border border-gray-200 bg-white outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400 transition";

export const SubmitBtn = ({ children, loading, ...props }) => (
  <button
    {...props}
    disabled={loading || props.disabled}
    className="w-full inline-flex items-center justify-center gap-2 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-60 text-white text-sm font-semibold py-2.5 rounded-lg transition-colors"
  >
    {loading && <span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />}
    {children}
  </button>
);

export default AuthShell;
